'use strict';

// animation requires scss '@import "components/in-view";' at intended scope

const TRIGGER_CLASS = 'js-in-view';
const VISIBLE_CLASS = 'in-view';

const observedElements = new WeakSet();

function observeElement(element) {
    observedElements.add(element);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0]?.isIntersecting) {
            element.classList.add(VISIBLE_CLASS);
            observer.unobserve(element);
        }
    });
    observer.observe(element);
}

function observeAllInView() {
    document.querySelectorAll(`.${TRIGGER_CLASS}:not(.${VISIBLE_CLASS})`).forEach((element) => {
        if (!observedElements.has(element)) {
            observeElement(element);
        }
    });
}

function revealAll() {
    document.querySelectorAll(`.${TRIGGER_CLASS}:not(.${VISIBLE_CLASS})`).forEach((element) => {
        element.classList.add(VISIBLE_CLASS);
    });
}

module.exports = function () {
    if (!('IntersectionObserver' in window)) {
        revealAll();
        document.body.addEventListener('product:tileRendered', revealAll);
        return;
    }

    observeAllInView();

    // dynamic injected product tiles
    document.body.addEventListener('product:tileRendered', observeAllInView);
};
